var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRechnung(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 62,
    viewBox: "0 0 98 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#707070;}.c{fill:#b30200;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 98,
    height: 62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0.904)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72,47.1H24v-34H72Zm-44-4H68v-26H28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 4,
    transform: "translate(32 27.612)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 12.662,
    height: 4,
    transform: "translate(32 20.612)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 4,
    transform: "translate(32 34.612)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4,
    height: 4,
    transform: "translate(59.283 27.612)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4,
    height: 4,
    transform: "translate(59.283 34.612)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechnung);
export default __webpack_public_path__ + "static/media/rechnung.c3c8ae2a031b8e29cd8c722da0a1e135.svg";
export { ForwardRef as ReactComponent };